import React from 'react';
import type {
  MobileNavMenuLinkGroups,
  MobileNavLink,
} from '../MobileNavMenuData/MobileNavMenuData';

import {
  Container,
  Title,
  Link,
  Icon,
  MenuParent,
  InnerUL,
  CaretRight,
  ulBaseStyles,
  liBaseStyles,
} from './MobileNavMenuLinkGroup.styles';

export type MobileNavMenuLinkGroupsProps = {
  title?: string;
  linkGroups: MobileNavMenuLinkGroups;
  setMenuData: (newMenuData: MobileNavMenuLinkGroups) => void;
  className?: string;
};

const MobileNavMenuLinkGroup = ({
  title,
  linkGroups,
  setMenuData,
  className,
}: MobileNavMenuLinkGroupsProps): JSX.Element => {
  const handleClick = (listItem: MobileNavMenuLinkGroups | MobileNavLink) => {
    if (!listItem.path) setMenuData(listItem as MobileNavMenuLinkGroups);
  };

  return (
    <Container className={className}>
      {title && <Title>{title}</Title>}
      <ul css={ulBaseStyles}>
        {linkGroups.linkGroups.map((group, groupIndex) => {
          return (
            <InnerUL key={groupIndex} css={ulBaseStyles}>
              {group.map((listItem, itemIndex) => {
                if (listItem.path) {
                  if (listItem.isDisabled) return null;
                  return (
                    <li key={itemIndex}>
                      <Link
                        href={listItem.path}
                        onClick={() => handleClick(listItem)}
                        target={listItem.target || '_self'}
                      >
                        {listItem.icon && <Icon src={`${listItem.icon}`} />}
                        {listItem.title}
                      </Link>
                    </li>
                  );
                }
                return (
                  <li key={itemIndex} css={liBaseStyles}>
                    <MenuParent onClick={() => handleClick(listItem)}>
                      {listItem.title}
                      <CaretRight direction="right" />
                    </MenuParent>
                  </li>
                );
              })}
            </InnerUL>
          );
        })}
      </ul>
    </Container>
  );
};

export default MobileNavMenuLinkGroup;
